
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarCheck, Baby } from "lucide-react";

interface GestationInfoProps {
  pregnancyStartDate: Date;
  dueDate: Date;
  currentWeek: number;
}

export const GestationInfo = ({ pregnancyStartDate, dueDate, currentWeek }: GestationInfoProps) => {
  // Map week to trimester
  const getCurrentTrimester = (week: number) => {
    if (week <= 13) return "1er";
    if (week <= 26) return "2ème";
    return "3ème";
  };

  const trimester = getCurrentTrimester(currentWeek);

  return (
    <div className="space-y-6">
      <Card className="transition-all duration-300 hover:shadow-md border-t-4 border-t-purple-500">
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2">
            <CalendarCheck className="h-5 w-5 text-purple-600" />
            Informations importantes
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-3 bg-purple-50 rounded-lg">
              <p className="text-sm text-purple-600 font-medium">Début de grossesse</p>
              <p className="font-medium text-lg text-purple-900">{format(pregnancyStartDate, 'PPP', { locale: fr })}</p>
            </div>
            <div className="p-3 bg-pink-50 rounded-lg">
              <p className="text-sm text-pink-600 font-medium">Date prévue d'accouchement</p>
              <p className="font-medium text-lg text-pink-900">{format(dueDate, 'PPP', { locale: fr })}</p>
            </div>
          </div>
        </CardContent>
      </Card>

      <Card className="transition-all duration-300 hover:shadow-md border-t-4 border-t-blue-500">
        <CardHeader className="pb-2">
          <CardTitle className="flex items-center gap-2">
            <Baby className="h-5 w-5 text-blue-600" />
            Progression de la grossesse
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="flex flex-col items-center gap-2">
            <div className="flex items-center justify-center gap-2">
              <div className="bg-blue-100 h-20 w-20 rounded-full flex items-center justify-center">
                <div className="text-3xl font-bold text-blue-700">{currentWeek}</div>
              </div>
              <div className="text-center flex flex-col">
                <p className="text-sm text-muted-foreground">Semaine de grossesse</p>
                <p className="text-lg font-medium text-blue-700">{trimester} trimestre</p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};
